// extracted by mini-css-extract-plugin
export default {"breakpoints-xs":"0","breakpoints-sm":"576px","breakpoints-md":"768px","breakpoints-lg":"992px","breakpoints-xl":"1200px","breakpoints-xxl":"1400px"};